import queryString from 'query-string';
import { fetchJWT } from '../chatbot/tokenApi';
import SessionStore from '../stores/SessionStore';

export function setAuthTokenForChatbot(
  apiBaseUrlPaas,
  accessToken,
  userTrackingId
) {
  const auth = {
    getAuthenticationToken: function getAuthenticationToken(callback) {
      fetchJWT(
        apiBaseUrlPaas,
        SessionStore.getSessionBankID() || 'CB',
        queryString.stringify({
          grant_type: 'client_credentials',
          scope: '1',
          get_user_info: 'true',
          bot_channel: 'ib',
        }),
        accessToken || SessionStore.getToken()['access_token'],
        userTrackingId
      )
        .then((jwt) => callback(jwt))
        .catch((error) => callback(null));
    },
  };
  window.auth = auth;
}
